module.exports = __webpack_public_path__ + "img/bot.78399594.png";